import socket from "socket.io-client";

class LiveTicketsClient {
  connection;
  con_url;
  path;

  constructor(con_url, path) {
    this.con_url = con_url;
    this.path = path;
  }

  /**
   *
   * @param {Function} onconnect
   * @param {Function} ondisconnect
   * @param {[{event: string, callback: Function}]} events
   */
  connect = (onconnect, ondisconnect, onerror) => {
    this.connection = socket.connect(this.con_url, {
      path: this.path
    });

    if(typeof onerror === "function") {
      this.connection.on("connect_error", onerror);
      this.connection.on("connect_failed", onerror);
      this.connection.on("error", onerror);
    }

    if (typeof onconnect === "function") {
      this.connection.on("connect", () => {
        this.connection.emit('authentication', {username: 'hackuderaiku', password: 'ukiaredukcah!@1'});
          onconnect();
        this.connection.on('authenticated', () => {
          onconnect();
        })
      });
    }

    if (typeof ondisconnect === "function") {
      this.connection.on("disconnect", ondisconnect);
    }
  };

  disconnect = () => {
    if (typeof this.connection === "object" && typeof this.connection.disconnect === "function"){
      this.connection.disconnect();
      delete this.connection;
    }
  }

  on = (event, callback) => {
    if(typeof event === "string" && typeof callback === "function" && this.connection) {
      this.connection.on(event, callback);
    }
  }

  error_handler = error => {
    console.error(error);
  };
}

export default new LiveTicketsClient("http://139.162.162.134");
